/* eslint-disable max-len */
import React from 'react'
import { string } from 'prop-types'

function Plants(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.38574 2.54382C9.77219 2.24133 10.3291 2.26292 10.6914 2.60827C11.6351 3.50912 12.3743 4.60346 12.8574 5.81531C13.126 6.48902 13.309 7.19113 13.4102 7.90515C14.8769 6.99399 16.5803 6.49894 18.335 6.4989C18.6 6.49899 18.8545 6.60452 19.042 6.79187C19.2293 6.97934 19.3349 7.23389 19.335 7.4989C19.3349 9.97414 18.3508 12.3482 16.6006 14.0985C14.8503 15.8486 12.4762 16.8319 10.001 16.8319C7.52581 16.8318 5.15158 15.8487 3.40137 14.0985C1.65121 12.3483 0.668055 9.97405 0.667969 7.4989C0.668008 7.23383 0.773553 6.97935 0.960938 6.79187C1.14843 6.60438 1.40282 6.49895 1.66797 6.4989C2.89341 6.4989 4.10707 6.73999 5.23926 7.20886C5.70961 7.40369 6.16136 7.63873 6.5918 7.90613C6.69293 7.19168 6.87679 6.4894 7.14551 5.81531C7.62866 4.60342 8.36687 3.50915 9.31055 2.60827L9.38574 2.54382ZM2.74707 8.578C2.97703 10.1235 3.69726 11.5662 4.81543 12.6844C5.93338 13.8024 7.37578 14.5216 8.9209 14.7518C8.83282 14.1604 8.67321 13.5802 8.44336 13.0253C8.07483 12.1357 7.53439 11.3272 6.85352 10.6464C6.17263 9.96552 5.36419 9.42502 4.47461 9.05652C3.91938 8.82655 3.33882 8.66603 2.74707 8.578ZM17.2539 8.578C15.7089 8.8082 14.2673 9.52854 13.1494 10.6464C12.0314 11.7644 11.3112 13.2065 11.0811 14.7518C12.6263 14.5218 14.0684 13.8024 15.1865 12.6844C16.3047 11.5662 17.0239 10.1235 17.2539 8.578ZM10.001 4.82117C9.58949 5.34827 9.25185 5.93117 9.00293 6.55554C8.63208 7.48576 8.46368 8.48412 8.50684 9.48425C9.10408 10.1277 9.60653 10.8516 10.001 11.6346C10.3928 10.8566 10.8935 10.1314 11.4951 9.48327C11.5381 8.48346 11.3698 7.48548 10.999 6.55554C10.7501 5.93118 10.4125 5.34825 10.001 4.82117Z"
        fill="#35424F"
      />
    </svg>
  )
}

Plants.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Plants
